import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideToastr } from 'ngx-toastr'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental'
import { initializeApp } from './initialize'
import { authReducer } from './store/auth.reducer'
import { authInterceptor } from '../all-services/base-service/interceptor.service'
import { provideStore } from '@ngrx/store'
import {
	provideRouter,
	withEnabledBlockingInitialNavigation,
	withHashLocation,
	withInMemoryScrolling,
	withRouterConfig,
	withViewTransitions
} from '@angular/router'
import { routes } from './app.routes'
import { DropdownModule, SidebarModule } from '@coreui/angular'
import { MAT_SELECTSEARCH_DEFAULT_OPTIONS, MatSelectSearchOptions } from 'ngx-mat-select-search'
import { NgxSpinnerModule } from 'ngx-spinner'
import { initializeNavigationService } from '../helper/shared/navigation.service'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { menuReducer } from './store/menu/menu.reducer'


export let appConfig: ApplicationConfig
appConfig = {
	providers: [
		importProvidersFrom(
			SidebarModule,
			DropdownModule,
			NgxSpinnerModule
		),
		initializeApp,
		initializeNavigationService,
		provideRouter(routes,
			withHashLocation(),
			withInMemoryScrolling({
				scrollPositionRestoration: 'top',
				anchorScrolling: 'enabled'
			}),
			withEnabledBlockingInitialNavigation(),
			withRouterConfig({
				onSameUrlNavigation: 'reload'
			}),
			withViewTransitions()
		),
		provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
		provideTanStackQuery(new QueryClient({
			defaultOptions: {
				queries: {
					retry: false,
					retryOnMount: false,
				}
			}
		})),
		provideToastr({
			preventDuplicates: true,
			countDuplicates: true,
			progressBar: true,
			progressAnimation: 'decreasing',
			positionClass: 'toast-top-center'
		}),
		provideStore({auth: authReducer, menu: menuReducer}),
		provideStoreDevtools({
			connectInZone: true
		}),
		{
			provide: MAT_SELECTSEARCH_DEFAULT_OPTIONS,
			useValue: <MatSelectSearchOptions> {
				// closeIcon: 'delete',
				noEntriesFoundLabel: 'هیچ موردی یافت نشد.'
				// placeholderLabel: 'متن مورد نظر را وارد کنید.'
			}
		},
		provideAnimationsAsync(),

	]
}
